import api from './api';
import { Client, CreateClientInput, UpdateClientInput } from '../types';

export async function getClients(): Promise<Client[]> {
  const response = await api.get<Client[]>('/clients');
  return response.data;
}

export async function getClient(id: string): Promise<Client> {
  const response = await api.get<Client>(`/clients/${id}`);
  return response.data;
}

export async function createClient(input: CreateClientInput): Promise<Client> {
  const response = await api.post<Client>('/clients', input);
  return response.data;
}

export async function updateClient(id: string, input: UpdateClientInput): Promise<Client> {
  const response = await api.put<Client>(`/clients/${id}`, input);
  return response.data;
}

export async function deleteClient(id: string): Promise<void> {
  await api.delete(`/clients/${id}`);
}
